import { Component, OnInit } from "@angular/core";
import { NavbarSnowComponent } from "./navbar-snow/navbar-snow.component";
import { CerrixLogoComponent } from "@app/shared/cerrix-logo/cerrix-logo.component";
import { NavbarLightropeComponent } from "./navbar-lightrope/navbar-lightrope.component";
import { NavbarI18nFeedbackComponent } from "./navbar-plugins/navbar-i18n-feedback/navbar-i18n-feedback.component";
import { NavbarCalendarComponent } from "./navbar-plugins/navbar-calendar/navbar-calendar.component";
import { NavbarBugReportComponent } from "./navbar-plugins/navbar-bug-report/navbar-bug-report.component";
import { NavbarHelpComponent } from "./navbar-plugins/navbar-help/navbar-help.component";
import { NavbarUserComponent } from "./navbar-plugins/navbar-user/navbar-user.component";
import { NavbarNewVersionComponent } from "./navbar-plugins/navbar-new-version/navbar-new-version.component";

@Component({
    selector: "navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
    imports: [
        NavbarSnowComponent,
        CerrixLogoComponent,
        NavbarLightropeComponent,
        NavbarI18nFeedbackComponent,
        NavbarCalendarComponent,
        NavbarBugReportComponent,
        NavbarHelpComponent,
        NavbarUserComponent,
        NavbarNewVersionComponent,
    ],
})
export class NavbarComponent implements OnInit {
    isHolidaySeason: boolean;
    lightsEnabled: boolean = false;

    constructor() {}

    ngOnInit(): void {
        this.checkHolidaySeasonDate();
    }

    checkHolidaySeasonDate() {
        const today = new Date();
        // Only in december active
        if (today.getMonth() == 11) {
            this.isHolidaySeason = true;
        }
    }
}
